import { OpenAPI } from "simplydo/interfaces";

export const verifications = (api) => ({
  searchForCompanies(
    country: string,
    companyNumber: string,
    companyName: string,
    forType: string,
    forId: string,
    success: (
      data: OpenAPI.GET<"/verifications/companies/search">["response"],
    ) => void,
    fail: (error: Error) => void,
    authToken: string,
  ) {
    api.maybeAuthenticatedRequest(
      "GET",
      `/verifications/companies/search?country=${country}&companyNumber=${companyNumber}&companyName=${encodeURIComponent(companyName)}&forType=${forType}&forId=${forId}${authToken ? `&authToken=${authToken}` : ""}`,
      null,
      success,
      fail,
    );
  },
  createReport(
    data: OpenAPI.POST<"/verifications/companies/reports">["requestBody"],
    success: (
      data: OpenAPI.POST<"/verifications/companies/reports">["response"],
    ) => void,
    fail: (error: Error) => void,
    authToken: string,
  ) {
    const { id, forType, forId, templatedFieldId } = data;
    api.maybeAuthenticatedRequest(
      "POST",
      "/verifications/companies/reports",
      {
        id,
        forType,
        forId,
        authToken: authToken || null,
        templatedFieldId: templatedFieldId || null,
      },
      success,
      fail,
    );
  },
  getReports(
    success: (
      data: OpenAPI.GET<"/verifications/companies/reports">["response"],
    ) => void,
    fail: (error: Error) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      "/verifications/companies/reports",
      null,
      success,
      fail,
    );
  },
});
